import { Component, OnInit }          from '@angular/core';
import { Router, 
  ActivatedRoute }                    from '@angular/router';
import { UserService }                from '../../_services/user.service';
import { AuthService }                from '../../auth/ind/auth.service';
import { first }          from 'rxjs/operators';
declare var $: any;
@Component({
  selector: 'ind-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.css']
})
export class ActivateComponent implements OnInit {

  parm: any;
  model: any;  
  loading:boolean = false;
  success:boolean = false;
  id_token: string;
  private sub: any;  
  acceptAgree: boolean = false;;
  viewedAgreement: boolean = false;;  
  submitted: boolean = false;
  constructor(
        private router: Router,
        private userService: UserService,
        private auth: AuthService,
        private route: ActivatedRoute        ) { }
  

  ngOnInit() {
    this.loading = false;
    this.success = false;
      
    //this.id_token = this.route.snapshot.params['id_token'];

    this.sub = this.route.params.subscribe(params => {
      //alert('Param s:'+params['s']) ;
      this.parm = params['s'];
    });
    var urlqry = decodeURIComponent(this.parm);
    var result = {};
    urlqry.split("&").forEach(function(part) {
      var item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    var tmpObj = {"firstname":"", "lastname":"", "email":""};
    tmpObj.firstname = result['f'];
    tmpObj.lastname = result['l'];
    tmpObj.email = result['e']?.toLowerCase().trim();  
    this.model = tmpObj;  
    this.id_token = result['token'];  

    console.log('id_token: ' + this.id_token);
    //alert("idtoken: "+this.id_token);
    this.acceptAgree = false;
    this.viewedAgreement = false;

  }

  ngAfterViewInit() {
    // remove modal init
  }

  acceptAgreement(){
    this.viewedAgreement = true;        
    this.acceptAgree = true;
    const jq = (window as any).$;
    jq('#myModal').modal('hide');
    jq('body').removeClass('modal-open');
    jq('.modal-backdrop').remove();
  }
  openModal(event: Event){
    event.preventDefault();
    const jq = (window as any).$;
    //console.log('window.$ version:', jq.fn.jquery);
    console.log('modal plugin:', typeof jq.fn.modal);
    jq('#myModal').modal('show');
  }
  activate(){
    this.loading = true;
    this.success = false;
    this.submitted = true;
    
    this.userService.activate(this.id_token)
        .pipe(first())
        .subscribe(
            data => {//alert('Activation is successful');
            this.success = true;
                //this.alertService.success('Registration successful', true);
                //this.router.navigate(['/ind-login']);
            },
            error => {//alert('Activation failed.'+JSON.stringify(error));
                
            });
          this.loading = false;
  }

  goToSignIn(){
    this.router.navigate(["/ind-login"]);
  }

}
